/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import { useCallback, useEffect, useState } from 'react';
import {
  MODAL_CONTROL_PLACEMENT_EVENT,
  MODAL_CONTROL_PLACEMENT_STORAGE_KEY,
  applyModalControlPlacementPreference,
  normalizeModalControlPlacement,
  readModalControlPlacementPreference,
  resolveModalControlPlacement,
  type ModalControlPlacementPreference,
} from '../utils/modal-control-placement.utils';

interface ModalControlPlacementEventDetail {
  preference?: unknown;
}

export function useModalControlPlacement() {
  const [preference, setPreferenceState] =
    useState<ModalControlPlacementPreference>(
      readModalControlPlacementPreference,
    );

  useEffect(() => {
    // Hosts without Core's bootstrap must resolve the saved platform style too.
    setPreferenceState(applyModalControlPlacementPreference(readModalControlPlacementPreference()));
    const handlePreferenceChange = (event: Event) => {
      const detail = (event as CustomEvent<ModalControlPlacementEventDetail>)
        .detail;
      setPreferenceState(
        normalizeModalControlPlacement(detail?.preference),
      );
    };
    const handleStorage = (event: StorageEvent) => {
      if (event.key !== MODAL_CONTROL_PLACEMENT_STORAGE_KEY) return;
      const next = applyModalControlPlacementPreference(event.newValue);
      setPreferenceState(next);
    };

    window.addEventListener(
      MODAL_CONTROL_PLACEMENT_EVENT,
      handlePreferenceChange,
    );
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener(
        MODAL_CONTROL_PLACEMENT_EVENT,
        handlePreferenceChange,
      );
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const setPreference = useCallback((value: unknown) => {
    const next = applyModalControlPlacementPreference(value);
    setPreferenceState(next);
  }, []);

  return {
    preference,
    resolved: resolveModalControlPlacement(preference),
    setPreference,
  };
}
